import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useIsVerboseLocale} from '@app/hooks/use-verbose-locale';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {TransferImage} from '@app/components/Assets/TransferImage';

export const TuneMyMusic: FunctionComponent = () => {
	const {t} = useTranslation();
	const isVerboseLocale = useIsVerboseLocale();
	const fontSize = isVerboseLocale
		? {base: 'xs', sm: 'sm', xl: 'md'}
		: undefined;
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'flowlandingpage_title_tellflowbyimportinglibraryinoneclick_standalone-web',
							{ns: 'flow'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'flowlandingpage_text_tellflowbyimportinglibraryinoneclick_standalone-web',
							{ns: 'flow'},
						)}
					</LandingParagraph>
				</>
			}
			image={<TransferImage w={{base: '300px', md: '800px'}} />}
			cta={
				<LandingButtonLink
					href="/features/transfer-playlist"
					tracking={{eventaction: 'discover', eventlabel: 'tune-my-music'}}
					fontSize={fontSize}
				>
					{t('generic_action_switchtodzr_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
